import { LocationQueryRaw, Router } from 'vue-router';

export const replaceQueryParams = (router: Router, routeName: string, query: LocationQueryRaw): void => {
  if (router.currentRoute.value.name !== routeName) {
    // only do this if the user is currently on this page and not some sub-route.
    return;
  }

  router.replace({
    name: routeName,
    query
  });
};
